module.exports = __webpack_public_path__ + "static/img/pattern-remove-pink.ea11985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pattern-remove-pink.png
// module id = qQ7s
// module chunks = 14